module.exports = __webpack_public_path__ + "static/media/logo-builder.54c4ce3a.png";